import RailsAssociation from './RailsAssociation';

export default RailsAssociation;
